import { Col, DatePicker, Row, Select, Typography } from "antd";
import React, { useState, useEffect } from "react";
import shipService from "@/services/shipService";
import { useQuery } from "react-query";
import dayjs from "dayjs";
import { formatDateToYYYYMMDD } from "@/lib";
import ownerService from "@/services/ownerService";

const { RangePicker } = DatePicker;

const ChartFilter = (props) => {
  const [selectedFormat, setSelectedFormat] = useState("Range");
  const [shiplist, setShiplist] = useState([]);
  const formatList = [
    { label: "Current Month", value: "Monthly" },
    { label: "Current Week", value: "Weekly" },
    { label: "Current Year", value: "Yearly" },
    { label: "Quartely", value: "3Months" },
    { label: "Last 6 Months", value: "6Months" },
    { label: "Range", value: "Range" },
  ];

  const EU_NONEULIST = [
    { label: "EU", value: "EU" },
    { label: "Non EU", value: "Non EU" },
  ];

  const shipId = localStorage.getItem("ship_id");
  const [voyageinfo, setVoyageInfo] = useState({
    voyagename: "",
    voyagenumber: "",
  });

  useEffect(() => {
    if (props.filteredProcessdata) {
      setSelectedFormat(props.filteredProcessdata?.date?.type || "Range");
      setVoyageInfo(
        props.filteredProcessdata?.voyage || {
          voyagename: "",
          voyagenumber: "",
        }
      );
    }
  }, [props.filteredProcessdata]);

  const { data: getvoyagelist } = useQuery(
    ["user-benchmark", shipId],
    () => shipService.getVoyagelist(shipId),
    { enabled: Boolean(shipId) }
  );

  const voyageList = [
    { label: "Ballast", value: "Ballast" },
    { label: "Laden", value: "Laden" },
  ];

  const handleChangeVoyage = (value, type) => {
    const updatedVoyage = {
      ...voyageinfo,
      [type === "number" ? "voyagenumber" : "voyagename"]: value,
    };
    setVoyageInfo(updatedVoyage);

    props.setFilterProcessData((prev) => ({
      ...prev,
      voyage: updatedVoyage,
    }));
  };

  const handleChange = (value) => {
    setSelectedFormat(value);
    if (!Array.isArray(value)) {
      props.setFilterProcessData((prev) => ({
        ...prev,
        date: {
          type: value,
          value: value,
        },
      }));
      return;
    }

    props.setFilterProcessData((prev) => {
      let dateValue;
      if (value === "Range") {
        dateValue = Array.isArray(prev.date?.value) ? prev.date.value : [];
      } else {
        dateValue =
          typeof prev.date?.value === "string" ? prev.date.value.trim() : "";
      }
      console.log("dateValue", value);
      return {
        ...prev,
        date: {
          type: value,
          value: dateValue,
        },
      };
    });
  };
 

  return (
    <div className="ms-3 mt-2">
      <Row gutter={[16, 16]}>
        {props?.filter_type !== "FAVOURITE" && <Col span={3}>
          <Typography.Text className=" text-white">Ship</Typography.Text>
          <Select
            className="mt-1"
            style={{ width: "100%" }}
            allowClear
            value={props.filteredProcessdata?.ship_id}
            onChange={(e) => {
              console.log("e", e);
              props.setFilterProcessData((prev) => ({
                ...prev,
                ship_id: e,
              }));
            }}
            placeholder="Select Ship"
            options={props?.shiplist?.map((x) => ({
              label: x?.name,
              value: x.imo_number,
            }))}
          />
        </Col>}

        <Col span={3}>
          <Typography.Text className=" text-white">Filter Type</Typography.Text>
          <Select
            className="mt-1"
            style={{ width: "100%" }}
            allowClear
            value={selectedFormat}
            onChange={handleChange}
            placeholder="Select Type"
            options={
              props?.selectedTopic?.includes("CII")
                ? formatList?.filter((x) => x?.value === "Range")
                : formatList
            }
          />
        </Col>

        {selectedFormat === "Range" && (
          <Col span={25}>
            <Typography.Text className=" text-white">
              Date Range
            </Typography.Text>
            <RangePicker
              className="mt-1"
              style={{ width: "100%" }}
              value={
                props.filteredProcessdata?.date?.type === "Range" &&
                  Array.isArray(props.filteredProcessdata.date.value)
                  ? props.filteredProcessdata.date.value.map((d) => dayjs(d))
                  : []
              }
              onChange={(e) => {
                if (!e || e.length !== 2) return;

                props.setFilterProcessData((prev) => ({
                  ...prev,
                  date: {
                    type: "Range",
                    value: Array.isArray(e)
                      ? e.map((x) => formatDateToYYYYMMDD(new Date(x)))
                      : [],
                  },
                }));
              }}
            />
          </Col>
        )}
        <Col span={11}>
          <Typography.Text className="my-3 text-white">Events</Typography.Text>
          <Select
            className="mt-1"
            showSearch
            allowClear
            mode="multiple"
            style={{ width: "100%" }}
            value={props.filteredProcessdata?.events || []}
            onChange={(e) =>
              props.setFilterProcessData((prev) => ({ ...prev, events: e }))
            }
            placeholder="Select Event"
          >
            {props.filterOptions?.map((x) => (
              <Select.Option key={x.value} value={x.value}>
                {x.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>

      {/* From and To Filters */}
      <Row gutter={[16, 16]} className="mt-3">
        <Col span={6}>
          <Typography.Text className=" text-white">From</Typography.Text>
          <Select
            className="mt-1"
            showSearch
            allowClear
            style={{ width: "100%" }}
            value={props?.filteredProcessdata?.eu_noneu?.from || null}
            placeholder="From"
            onChange={(e) =>
              props.setFilterProcessData((prev) => ({
                ...prev,
                eu_noneu: { from: e, to: prev?.eu_noneu?.to || "" },
              }))
            }
          >
            {EU_NONEULIST.map((x) => (
              <Select.Option key={x.value} value={x.value}>
                {x.label}
              </Select.Option>
            ))}
          </Select>
        </Col>

        <Col span={6}>
          <Typography.Text className=" text-white">To</Typography.Text>
          <Select
            className="mt-1"
            showSearch
            allowClear
            style={{ width: "100%" }}
            value={props?.filteredProcessdata?.eu_noneu?.to || null}
            placeholder="To"
            onChange={(e) =>
              props.setFilterProcessData((prev) => ({
                ...prev,
                eu_noneu: { to: e, from: prev?.eu_noneu?.from || "" },
              }))
            }
          >
            {EU_NONEULIST.map((x) => (
              <Select.Option key={x.value} value={x.value}>
                {x.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={6}>
          <Typography.Text className="  text-white">
            Voyage Number
          </Typography.Text>
          <Select
            className="mt-1"
            showSearch
            allowClear
            style={{ width: "100%" }}
            value={voyageinfo.voyagenumber || null}
            onChange={(e) => handleChangeVoyage(e, "number")}
            placeholder="Voyage Number"
          >
            {getvoyagelist?.map((x) => (
              <Select.Option key={x.label} value={x.label}>
                {x.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={6}>
          <Typography.Text className=" text-white">Voyage Type</Typography.Text>
          <Select
            className="mt-1"
            allowClear
            style={{ width: "100%" }}
            value={voyageinfo.voyagename || null}
            onChange={(e) => handleChangeVoyage(e, "name")}
            placeholder="Voyage Type"
          >
            {voyageList.map((x) => (
              <Select.Option key={x.value} value={x.value}>
                {x.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>

      {/* Voyage Filters */}
      <Row gutter={[16, 16]} className="mt-3"></Row>
    </div>
  );
};

export default ChartFilter;
